/** Slug URL-safe a partir de texto visible (sin tildes). */
export function slugifyName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Elige un slug libre dentro de `taken` (mutado al asignar). */
export function takeUniqueSlug(base: string, taken: Set<string>, idSuffix: string): string {
  const root = base || `item-${idSuffix.slice(-6)}`;
  if (!taken.has(root)) {
    taken.add(root);
    return root;
  }
  let candidate = `${root}-${idSuffix.slice(-4)}`;
  let n = 2;
  while (taken.has(candidate)) {
    candidate = `${root}-${idSuffix.slice(-4)}-${n++}`;
  }
  taken.add(candidate);
  return candidate;
}
